import { render, staticRenderFns } from "./OnboardingSlider.vue?vue&type=template&id=29079a1b&scoped=true&"
import script from "./OnboardingSlider.vue?vue&type=script&lang=js&"
export * from "./OnboardingSlider.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSlider.vue?vue&type=style&index=0&id=29079a1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29079a1b",
  null
  
)

export default component.exports